<template>
  <v-btn
    :variant="variant"
    :size="size"
    :color="color"
    icon
    class="theme-switcher"
    :title="nextThemeLabel"
    @click="toggleTheme"
  >
    <v-icon>mdi-palette-outline</v-icon>
  </v-btn>
</template>

<script setup>
import { computed } from 'vue'
import { useTheme } from 'vuetify'
import { useI18n } from 'vue-i18n'

defineProps({
  variant: { type: String, default: 'outlined' },
  size: { type: String, default: 'small' },
  color: { type: String, default: 'primary' }
})

const theme = useTheme()
const { t } = useI18n()

const STORAGE_KEY = 'korkem-auto-theme'
const THEME_ORDER = ['dark', 'korkem']

const currentTheme = computed(() => theme.global.name.value)

const nextTheme = computed(() => {
  const idx = THEME_ORDER.indexOf(currentTheme.value)
  return THEME_ORDER[(idx + 1) % THEME_ORDER.length]
})

const nextThemeLabel = computed(() => {
  const labels = {
    dark:   t('theme.classic') || 'Классикалық',
    korkem: t('theme.korkem')  || 'Korkem (көк)'
  }
  return labels[nextTheme.value]
})

const toggleTheme = () => {
  const name = nextTheme.value
  theme.change(name)
  try { localStorage.setItem(STORAGE_KEY, name) } catch { /* ignore */ }
}
</script>

<style scoped>
.theme-switcher { border-radius: 8px; }
</style>
